__turbopack_context__.v({
  "className": "aJIwla_className",
  "variable": "aJIwla_variable",
});
